import { objConstants } from '../constants';
import { baseService } from '../services';
import { alertActions } from './';
import { history } from '../helpers';

export const baseActions = {
    add,
    edit,
    gets,
    getall,
    get,
    delete: _delete,
    post,
    getBlob,
    postback
};


function postback(obj,controller,method,params,func=null) {

   
    return dispatch => {
        
       
        
       // dispatch(request(null))

        baseService.post(obj,controller,method,params)
            .then(
                objs => { 
                    dispatch(success(objs));
                    //history.push(`/${objType.toLowerCase()}`);
                   // dispatch(alertActions.success('آیتم مورد نظر با موفقیت ویرایش شد'));
                    if(func!=null)
                    {
                        dispatch(func);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request() { return { type: objConstants.GET_REQUEST } }
    function success(obj) { return { type: objConstants.GET_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.GET_FAILURE, error } }
}

function post(obj,controller,method,params,func=null) {

   
    return dispatch => {
        
       
        
        //dispatch(request(obj))

        baseService.post(obj,controller,method,params)
            .then(
                objs => { 
                    dispatch(success(objs));
                    //history.push(`/${objType.toLowerCase()}`);
                    dispatch(alertActions.success('آیتم مورد نظر با موفقیت ویرایش شد'));
                    if(func!=null)
                    {
                        dispatch(func);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(obj) { return { type: objConstants.ADD_REQUEST, obj } }
    function success(obj) { return { type: objConstants.ADD_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.ADD_FAILURE, error } }
}

function add(obj,controller,params=null,func=null) {

    console.log('baseactions',obj);
    console.log('dispatch');
    return dispatch => {
        
       
        
        dispatch(request(obj))

        baseService.post(obj,controller,'',params)
            .then(
                objs => { 
                    dispatch(success(objs));
                    //history.push(`/${objType.toLowerCase()}`);
                    dispatch(alertActions.success('آیتم مورد نظر با موفقیت ایجاد شد'));
                    if(func!=null)
                    {
                        dispatch(func);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(obj) { return { type: objConstants.ADD_REQUEST, obj } }
    function success(obj) { return { type: objConstants.ADD_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.ADD_FAILURE, error } }
}

function edit(obj,controller,id,params=null,func =null) {
    return dispatch => {
        dispatch(request(obj));

        baseService.put(obj,controller,id,params)
            .then(
                objs => { 
                    dispatch(success(objs));
                    //history.push(`/${objType.toLowerCase()}`);
                    dispatch(alertActions.success('آیتم مورد نظر با موفقیت ویرایش شد'));
                    if(func!=null)
                    {
                        dispatch(func);
                    }
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(obj) { return { type: objConstants.UPDATE_REQUEST, obj } }
    function success(obj) { return { type: objConstants.UPDATE_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.UPDATE_FAILURE, error } }
}

function gets(controller, page, perPage, sortField, sortOrder,filter,params=null) {
    return dispatch => {
        dispatch(request());

        baseService.get(controller, '',  'page=' + page + '&&perPage=' + perPage + ((sortField) ? ('&&sort=' + sortField + ' ' + sortOrder) : '') + ((filter) ? ('&&filter=' + filter ) : '') + ((params) ? ('&&'+ params ) : ''))
            .then(
                objs => dispatch(success(objs)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: objConstants.GETALL_REQUEST } }
    function success(objs) { return { type: objConstants.GETALL_SUCCESS, objs } }
    function failure(error) { return { type: objConstants.GETALL_FAILURE, error } }
}
function getall(controller,method='') {
    return dispatch => {
        dispatch(request());

        baseService.get(controller, method)
            .then(
                objs => dispatch(success(objs)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: objConstants.GETALL_REQUEST } }
    function success(objs) { return { type: objConstants.GETALL_SUCCESS, objs } }
    function failure(error) { return { type: objConstants.GETALL_FAILURE, error } }
}


function get(controller,id) {
    
    return dispatch => {
        dispatch(request());

        baseService.get(controller,id)
            .then(
                objs => dispatch(success(objs)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: objConstants.GET_REQUEST } }
    function success(obj) { return { type: objConstants.GET_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.GET_FAILURE, error } }
}



function getBlob(controller,method,params) {
    
    return dispatch => {
        dispatch(request());

        baseService.getBlob(controller,method,params)
            .then(
                objs => dispatch(success(objs)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: objConstants.GET_REQUEST } }
    function success(obj) { return { type: objConstants.GET_SUCCESS, obj } }
    function failure(error) { return { type: objConstants.GET_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id,controller,func =null) {
    return dispatch => {
        dispatch(request(id));

        baseService.delete(controller,id)
            .then(
                objs => 
                {
                    dispatch(success(objs))
                    if(func!=null)
                    {
                        dispatch(func);
                    }
                },
                error =>{ 
                    dispatch(failure(id, error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(id) { return { type: objConstants.DELETE_REQUEST, id } }
    function success(obj) { return { type: objConstants.DELETE_SUCCESS, obj } }
    function failure(id, error) { return { type: objConstants.DELETE_FAILURE, id, error } }
}